// extracted by mini-css-extract-plugin
module.exports = {"confirm-buttons":"modals_confirm-buttons__1YwNb","confirm-message":"modals_confirm-message__1ov6Z"};